export default function About() {
    return (
        <div>
            <h1>Projects</h1>
            <div class="projects-container">
        <a href="https://github.com/hventayen/forgehv.git" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Portfolio Website</h2>
                    <p>- Created a React website with 3D components using three.js to make a portfolio website</p>
                    <p>- Converted real objects into 3D models using a 3D scanner and made them viewable as a .gbl with Drei API</p>
                    <p>- Explored using button components to initiate animations using 3D Framer Motion API</p>
                </div>
                <div class="project-image">
                    <img src="https://github.com/hventayen/3d/blob/main/3d.png?raw=true" alt=''/>
                </div>
            </div>
        </a>

        <a href="https://la-tech.org/google-calendar-1-1-1-1-1" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Customized Squarespace Calendar</h2>
                    <p>- Constructed code blocks with HTML, CSS, & JS to customize a calendar in LA-Tech website</p>
                    <p>- Utilized APIs to import information from Google Calendar & make the data more appealing</p>
                    <p>- Enhanced functionality to preview attachments & control positioning of event details</p>
                    <p>- Built wireframes with Figma to coordinate website styling & structure with marketing dept</p>
                </div>
                <div class="project-image">
                    <img src="https://github.com/hventayen/Calendar/blob/main/calendar.png?raw=true" alt=''/>
                </div>
            </div>
        </a>

        <a href="https://www.google.com" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Alumni Web Scraper</h2>
                    <p>- Developed a python web scraper that tracks alumni achievements after graduating at LA-Tech</p>
                    <p>- Extracted public data of alumni job experience and consolidated data into spreadsheets</p>
                    <p>- Data proposed effective changes in the company’s curriculum and optimized internship team’s focus towards desired industry roles</p>
                </div>
                <div class="project-image">
                    <img src="https://github.com/hventayen/scraper/blob/main/scraper.png?raw=true" alt=''/>
                </div>
            </div>
        </a>
        <a href="https://github.com/hventayen/Rosay" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Rosay Website</h2>
                    <p>- Created a react front end of a photography company website that showcases their work</p>
                    <p>- Articulated employers’ needs, proposed design choices, and implemented solutions</p>
                    <p>- Learned to create work plans and research front end techniques to make an appealing website</p>
                    <p>- Utilized docker files in order to automate execution of react website</p>
                </div>
                <div class="project-image">
                    <img src="https://media.licdn.com/dms/image/v2/D562DAQHSs49cDk5Y3A/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1707118994479?e=1727182800&v=beta&t=ev97dBXJAEnie2noQA4efyeCMHALyfNe1HK8Yyj5DXA" alt=''/>
                </div>
            </div>
        </a>
        <a href="https://docs.google.com/presentation/d/1wf5tu2-Xwr2rqkvWMlXTLolcyYOwQNvlh-Hz9EG32zI/edit?usp=embed_facebook" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>System Administration AWS EC2 Web Server</h2>
                    <p>- Utilized AWS to set up an EC2 web server and its settings for security and storage in group project</p>
                    <p>- Used wordpress to connect to an EC2 instance’s public IP address to access the wordpress installation web service there</p>
                    <p>- Configured mysql database on a second ec2 instance to access the data backend for wordpress a database in wordpress to contain the details of username and password</p>
                </div>
                <div class="project-image">
                    <img src="https://media.licdn.com/dms/image/v2/D562DAQEvg4YjJpQ-QQ/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1707114857568?e=1727182800&v=beta&t=XE-Au9OpV6YuUPmWn4wbDQW9PIH-MX6tbqdKFxjzTJU" alt=''/>
                </div>
            </div>
        </a>
        <a href="https://github.com/hventayen/cpsc411-finalproject-spring2023-main" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Quiz-Lingo</h2>
                    <p>- Created a Kotlin app that introduces language learning in a creative way with classmates</p>
                    <p>- Allow users to be given a sense of immersion by the use of images</p>
                    <p>- Adapted for multiple languages, data persistence, image & translator APIs used to generate questions</p>
                </div>
                <div class="project-image">
                    <img src="https://media.licdn.com/dms/image/v2/D562DAQEdx75PTQhfCQ/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1707109865352?e=1727182800&v=beta&t=oCUftVjCtElskWjDmdJO8B4qPzM3q7MhLbAM8lj0O-g" alt=''/>
                </div>
            </div>
        </a>
        <a href="https://github.com/hventayen/Project5-Asynchronous-Service-Orchestration" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Wordle Backend</h2>
                    <p>- Developed a Python Backend in order to recreate the functionality of Wordle in a group project</p>
                    <p>- Uvicorn used as load balancer to execute and maintain multiple services concurrently</p>
                    <p>- Utilized Redis to shard separate databases for guesses, word bank, and game ids</p>
                </div>
                <div class="project-image">
                    <img src="https://media.licdn.com/dms/image/v2/D562DAQHEgJS5GSmqbA/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1707110983467?e=1727182800&v=beta&t=CpYqUybP9NYgEOAaSDwSysBXsT_KZBd5dV1xl5_i08c" alt=''/>
                </div>
            </div>
        </a>
        <a href="https://codepen.io/hventayen/details/eYGpjXa" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Codepen Cat</h2>
                    <p>- Instructed a student on an interactive cat that responded using mouse clicks and hovers</p>
                    <p>- Avoided the regular format of a website utilizing html, css, and js topics in a creative way</p>
                    <p>- Customized a lesson plan teaching the student the basics of html, css, and js</p>
                </div>
                <div class="project-image">
                    <img src="https://media.licdn.com/dms/image/sync/v2/D5627AQEHN-tsPBehLg/articleshare-shrink_160/articleshare-shrink_160/0/1710866549462?e=1727182800&v=beta&t=hcGRv1vW2lBb7MVMIwFikIIaeocgMbcxvH3DyfYaugc" alt=''/>
                </div>
            </div>
        </a>
        <a href="https://github.com/CSUF-CPSC223W-2021S01/project-programmers" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Dump The Bump</h2>
                    <p>- Collaborated with peers on a Swift app that lets pregnant mothers monitor their weight</p>
                    <p>- Acquired skills in mobile applications and connecting front end to back end code</p>
                    <p>- Utilized Encoders/Decoders to save info in files and pass objects between classes in Swift</p>
                </div>
                <div class="project-image">
                    <img src="https://media.licdn.com/dms/image/v2/D562DAQHDkQOZAG4koA/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1707107633400?e=1727182800&v=beta&t=UoA0_og8khxXRG7vniuZLA8RzFwlksR8x4Ah5sXsu3I" alt=''/>
                </div>
            </div>
        </a>
        <a href="https://github.com/hventayen/epp12" class="project-link">
            <div class="project">
                <div class="project-description">
                    <h2>Data Structures Fruit Prices Sorter</h2>
                    <p>- Created a sorter in C++ that categorizes list of fruits by its prices</p>
                    <p>- Utilized a Vector of Structs to read in entries of a txt file and sort its contents</p>
                    <p>- Submission for CSUF's Placement Exam: Exam in Programming Proficiency EPP</p>
                    <p>- Studied topics such as Data Structures and Object Oriented Programming</p>
                </div>
                <div class="project-image">
                    <img src="https://media.licdn.com/dms/image/v2/D562DAQExy7LMTS7tYQ/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1707105921218?e=1727182800&v=beta&t=PDuAquyaJpbNeuUD2mmvQLnhstXMf9L0oiG_UVogbKE" alt=''/>
                </div>
            </div>
        </a>
    </div>
    </div>
        )
}